/**
 * Weapon tuning (docs/gameplay/weapon-tuning.md): a weapon is set by its
 * damage per second and attacks per second, and its damage per second by the
 * level curve for its drop level, times its family's factor and its quality.
 * Each weapon's per-hit damage and cooldown are set in its item file
 * (game-content/data/items/, #296); this is the curve they are picked from.
 */

/** Damage per second of a level 1 weapon: the starter Shortsword. */
export const WEAPON_DPS_AT_LEVEL_ONE = 9;
/** How much stronger each drop level's weapons are than the last. */
export const WEAPON_DPS_GROWTH_PER_LEVEL = 1.1;

/** The level curve: a baseline (one-handed sword, quality 1.0) weapon's damage per second at a drop level. */
export function resolveWeaponDpsForLevel(dropLevel: number): number {
    return WEAPON_DPS_AT_LEVEL_ONE * Math.pow(WEAPON_DPS_GROWTH_PER_LEVEL, Math.max(0, dropLevel - 1));
}
